import {ExternalBackend} from "./ExternalBackend";

export class RocketgateWorkflow extends ExternalBackend {

  constructor(params) {
    super("rocketgate", params);
  }
}